const isHiddenTemplate = (path) => {
    const hiddenTemplates = ["profile", "login", "notifications"];
    const dynamicRoutes = [/^documents\/[^/]+$/, /^news\/[^/]+$/];

    return hiddenTemplates.includes(path) || dynamicRoutes.some((regex) => regex.test(path));
};

export const headerVisibility = () => {
    const links = window.location.pathname.slice(1, -1);
    const header = document.getElementById("header");

    if (!header) return;

    if (isHiddenTemplate(links)) {
        header.style.display = "none";
        return;
    }

    const homeHeaderTemplates = ["home", ""];
    header.classList.toggle("header-home", homeHeaderTemplates.includes(links));
};
